import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import llaveService from "../../services/llaveService";

// Thunk para crear el árbol de llaves y guardarlo en la BD
export const crearArbolThunk = createAsyncThunk(
  "llave/crearArbol",
  async ({ tournamentTree, idTorneoCategoria }, thunkAPI) => {
    try { 
      console.log("tournamentTree", tournamentTree);
      const data = await llaveService.crearArbol(tournamentTree, idTorneoCategoria);
      console.log("data", data);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk para obtener llaves
export const obtenerLlavesPorTorneoThunk = createAsyncThunk(
  "llave/obtenerPorTorneo",
  async (idTorneoCategoria, thunkAPI) => {
    try {
      const data = await llaveService.obtenerLlavesPorTorneoCategoria(idTorneoCategoria);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk para obtener partidos estructurados
export const obtenerPartidosEstructuradosThunk = createAsyncThunk(
  "llave/obtenerPartidosEstructurados",
  async (idTorneoCategoria, thunkAPI) => {
    try {
      const data = await llaveService.obtenerPartidosEstructurados(idTorneoCategoria);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Estado inicial
const initialState = {
  llaves: [],
  partidosEstructurados: [], // Almacena los partidos ya procesados
  isLoading: false,
  error: null,
};

const llaveSlice = createSlice({
  name: "llave",
  initialState,
  reducers: {
    resetLlaveState: (state) => {
      state.llaves = [];
      state.partidosEstructurados = [];
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // CREAR ÁRBOL
    builder
      .addCase(crearArbolThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(crearArbolThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        const { rootLlave } = action.payload;
        state.llaves.push(rootLlave);
      })
      .addCase(crearArbolThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // OBTENER LLAVES
      .addCase(obtenerLlavesPorTorneoThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(obtenerLlavesPorTorneoThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.llaves = action.payload;
      })
      .addCase(obtenerLlavesPorTorneoThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // OBTENER PARTIDOS ESTRUCTURADOS
      .addCase(obtenerPartidosEstructuradosThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(obtenerPartidosEstructuradosThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.partidosEstructurados = action.payload;
      })
      .addCase(obtenerPartidosEstructuradosThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetLlaveState } = llaveSlice.actions;
export default llaveSlice.reducer;
